// extracted by mini-css-extract-plugin
module.exports = {"image":"error-modal_image__2GeoC","container":"error-modal_container__35pOn","title":"error-modal_title__1Lvzo"};